import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Blocks Planner role from accessing Masters and Settings.
 * Renders children for non-Planner; redirects Planner to dashboard.
 */
const PlannerBlockGuard = ({ children }) => {
  const { user, isPlanner } = useAuth();
  if (!user) return null;
  if (isPlanner) return <Navigate to="/dashboard" replace />;
  return children;
};

export default PlannerBlockGuard;
